export type PageStatus = "Ready" | "Missing Query Parameters" | "Sending" | "Succeeded" | "Failed" | "Redirect" | "CompleteRegistration";

export interface PageModel {
  title: string;
  titleImage: string;
  informationMessages: string[];
  errorMessages: string[];
  showButton: boolean;
  buttonTitle: string;
  showFooter: boolean;
}

export function createInitialPageModel(): PageModel {
  return {
    title: "",
    titleImage: "",
    informationMessages: new Array<string>(),
    errorMessages: new Array<string>(),
    showButton: true,
    buttonTitle: "",
    showFooter: true
  };
}
